(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["api-actions"]) return;
  try {
    
$(window).load(function(){

    var attrs = {
        dob:            null, 
        state:          null,
        age:            null,
        eligable:       null,
        is_eligable:    false
    }
    $('.js-cart-attr-reset').on('click', function(){
        $.ajax({
            type:   'POST',
            url:    '/cart/update.js', 
            dataType: 'json',
            data:   { attributes: attrs },
            success: function( response ) {
                $('.api-cart-attr').text( JSON.stringify(response.attributes) ); 
            }
        });
    });

    $('.js-modal-button').on('click', function(){
        $('.js-modal-check').addClass('modal--is-active');
    });

    var urlProducts = 'https://verybigthings-test-store.myshopify.com/admin/api/2020-01/products.json';
    $.ajax({
        type: 'GET',
        url: urlProducts,
        dataType: 'json',
        success: function(data) { 
            //$('.api-products').text( JSON.stringify(data.products) );
            $('.api-products').text( "Preview disabled atm." );
        }
    });

    var urlCart = '/cart?view=json';
    var htmlCart = '';
    $.ajax({
        type: 'GET',
        url: urlCart,
        success: function(cartData) { 
            var cartItems = JSON.parse(cartData);
            if( cartItems.items.length > 0 ){
                cartItems.items.map( function(item){
                    htmlCart += '<p>';
                    htmlCart += '<strong>' + item.title + '</strong>';
                    htmlCart += ' / ';
                    htmlCart += '' + item.id + '';
                    htmlCart += ' / ';
                    htmlCart += 'Requires questionnaire: ';
                    htmlCart += (item.questionare == "true") ? "yes" : "no";
                    htmlCart += '</p>';
                })
            }else{
                htmlCart += 'No items in cart.';
            }
            $('.api-cart').html( htmlCart );

            $('.api-cart').text( "Preview disabled atm." );
        }
    });

    var urlZones = 'https://verybigthings-test-store.myshopify.com/admin/api/2020-01/shipping_zones.json';
    var htmlZones = '';
    $.ajax({
        type: 'GET',
        url: urlZones,
        dataType: 'json',
        success: function (cartZones, textStatus) {
            if( cartZones.shipping_zones.length > 0 ){
                cartZones.shipping_zones.map( function(item){

                    htmlZones += '<p>';
                    htmlZones += '<label class="simple-label">Zone</label>';
                    htmlZones += '<strong>' + item.name + '</strong>';
                    htmlZones += '<br />';
                    htmlZones += '<label class="simple-label" style="margin-left: 20px;">Zone > Country</label>';
                    htmlZones += '<br />';

                    // zone countries
                    item.countries.map(function(country){
                        htmlZones += '<small style="margin-left: 20px;">' + country.name + '</small>';
                        htmlZones += '<br />';

                        // zone country provinces
                        if( country.provinces.length > 0 ){
                            htmlZones += '<label class="simple-label" style="margin-left: 40px;">Zone > Country > Provinces</label>';
                            htmlZones += '<br />';
                            country.provinces.map(function(province){   
                                htmlZones += '<small style="margin: 0 4px;">' + province.name + '</small>';
                            });
                            htmlZones += '<br />';
                        }
                    });

                    htmlZones += '</p>';
                })
            }else{
                htmlZones += 'No shipping zones set.';
            }
            $('.api-zones').html( htmlZones );

            $('.api-zones').text( "Preview disabled atm." );
        }
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    

$(window).load(function(){

    checkPrescription(false);

    var attrs = {
        dob:            null, 
        state:          null,
        age:            null,
        eligable:       null,
        is_eligable:    false
    }
    $('.js-cart-attr-reset').on('click', function(){
        $.ajax({
            type:   'POST',
            url:    '/cart/update.js', 
            dataType: 'json',
            data:   { attributes: attrs },
            success: function( response ) {
                $('.api-cart-attr').text( JSON.stringify(response.attributes) ); 
            }
        });
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){

  var $headerElem = $('#shopify-section-header');

  $(document).on('scroll', function(){
    if( $(document).scrollTop() > 100 ){
      $('body').addClass('sticky');
    }else{
      $('body').removeClass('sticky');
    }
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-check"]) return;
  try {
    
$(window).load(function(){    

    // init datepicker
    $('#modalCheckDate').datepicker({
        changeYear: true,
        dateFormat: "mm-dd-yy",
        yearRange: "1900:2030"
    });

    // do check
    $('.js-modal-submit').on('click', function(){ 

        // default modal state
        $('.js-modal-response-loader').removeClass('hide');
        $('.js-modal-response-content').empty();
        $('.js-add-proceed').addClass('hide');

        // create cart attrs
        var attrs = {
            dob:            $('#modalCheckDate').val(),
            state:          $('#modalCheckState').val(),
            age:            0,
            ageExpected:    21,
            eligable:       {state: false, age: false},
            is_eligable:    false
        };

        var urlZones = 'https://7cells.xyz/shopify/shipping_zones';
        
        var htmlZones = '';
        $.ajax({
            method:     'GET',
            url:        urlZones,
            dataType:   'json',
            cache:      false,
            beforeSend: function(xhr){
                // xhr.setRequestHeader('Authorization', 'Basic ' + apiBase64);
                // xhr.setRequestHeader('X-Shopify-Access-Token', apiPass);
            },
            success: function (response, textStatus) {

           
                response.data.map( function( group ){
                    group.countries.map(function( country ){
                        if( country.code == "US" ){
                            country.provinces.map(function( province ){
                                if( attrs.state == province.code ){
                                    attrs.eligable.state = true;
                                }
                            })
                        }
                    });
                })

                // check dob here
                var userDob = attrs.dob.split('-');
                var dt1 = new Date(userDob[2],userDob[0], userDob[1]);
                var dt2 = new Date();
                attrs.age = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) / (1000 * 60 * 60 * 24 * 365) );
                /*
                console.log(
                    "now:",
                    dt2.getFullYear(), dt2.getMonth(), dt2.getDate(), 
                    "user:",
                    dt1.getFullYear(), dt1.getMonth(), dt1.getDate(), 
                attrs );
                */
                
                attrs.eligable.age = ( parseInt(attrs.age) >= parseInt(attrs.ageExpected) ) ? true : false;

                // overall eligable
                attrs.is_eligable = ( attrs.eligable.age && attrs.eligable.state ) ? true : false;

                // set cart attr
                $.ajax({
                    method:   'POST',
                    url:    '/cart/update.js', 
                    dataType: 'json',
                    data:   { attributes: attrs },
                    success: function( response ) {

                        // hide loader
                        $('.js-modal-response-loader').addClass('hide');

                        var msg = '';

                        // update cta-s
                        if( attrs.is_eligable === true ){
                            $('.js-add-original').removeClass('hide');
                            $('.js-add-check').addClass('hide');
                            $('.js-add-proceed').removeClass('hide');
                            $('.js-modal-submit').addClass('hide');

                            // show message
                            msg += "<strong>Great news! You are eligible to purchase this product.</strong>";
                        }else{
                            $('.js-add-original').addClass('hide');
                            $('.js-add-check').removeClass('hide');
                            $('.js-add-proceed').addClass('hide');
                            $('.js-modal-submit').removeClass('hide');

                            // show message
                            msg += "<strong>Unfortunately you do not meet the requirements to purchase this product at this time.</strong>"
                            if( !attrs.eligable.state ){
                                msg += "<br />We are not licensed in that state yet. Please check again soon.";
                            }
                            if( !attrs.eligable.age ){
                                msg += "<br />It seems you do not meet the minimum age requirements for this product.";
                            }
                        }

                        $('.js-modal-response-content').html(msg);

                    }
                });


            },
            error: function(response){
                $('.js-modal-response-loader').addClass('hide');
                $('.js-modal-response-content').html('Request Error' );
            }
        });

    });

    // close modal
    $(document).on('click', '.js-modal-close', function(){ 
        $('.js-modal-check').removeClass("modal--is-active");
    });
    
    // close on outside click
    var modal = document.querySelector('#modal-check');
    $(window).on('click', function(){
        if (event.target == modal) {
            if (typeof(modal) != 'undefined' && modal != null){
                $('.js-modal-check').removeClass("modal--is-active");
            }
        }
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
$(window).load(function(){

  $('[data-additional-title]').on('click', function(){
    $(this).parent().toggleClass('open');
  });

  $('.js-modal-button').on('click', function(){
    $('.js-modal-check').addClass('modal--is-active');
  });

});

  } catch(e) { console.error(e); }
})();

})();
